import React from 'react';
import { Box, Button, Divider, Typography } from '../elements';
import { t } from '../../../js/common/translations';

const AmenitiesList = ({ servicesList, building }) => {
  return (
    <Box>
      {
        servicesList.map((item, i) => (
          <>
            <Box key={i} sx={{ my: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Box>
                <Typography sx={{ fontSize: '20px', fontWeight: '500', textTransform: 'capitalize' }}>{item.home_type}</Typography>
                <Typography sx={{ fontSize: '14px' }}>{t('services_page.amenities.daily_cost')} {item.formatted_daily_price}</Typography>
              </Box>
              <Box>
                <Button
                  variant='outlined'
                  size="small" sx={{
                    '&.MuiButton-root':
                    {
                      padding: '4px 16px',
                      background: '#FEFEFE'
                    }
                  }}
                  href={`${t('services_page.amenities.whatsapp_amenities')}${t('services_page.amenities.building_and_service', {
                    building_name: building.internal_id,
                    service_name: item.home_type
                  })} ${item.internal_id}`}
                >
                  <Typography sx={{ fontSize: '12px', fontWeight: '500' }}>{t('services_page.amenities.book_now')}</Typography>
                </Button>
              </Box>
            </Box>
            {servicesList.length !== i + 1 &&
              <Divider sx={{ borderColor: '#E3E4E8', opacity: 1 }} />
            }
          </>
        ))
      }
    </Box>
  );
};

export default AmenitiesList;
